import * as T from '@/types'
import Vue, { Component } from 'vue'

////////////////////////////////////////////////////////////////
// interfaces
////////////////////////////////////////////////////////////////

export interface DataTypeDefinition {
    type: T.DataType
    name: string
    icon: string

    // input
    inputComponent: Vue | Component
    getInputComponentProps?: () => {[key: string]: any}
    getDefaultInputValue: () => any

    // filter
    filterType?: T.FilterType
    filterComponent?: Vue | Component
    getFilterComponentProps?: () => {[key: string]: any}
    getDefaultFilterValue?: () => any
    
    // sort
    defaultSortAscending?: boolean

    // display
    getDataText: (...params: any[]) => string | null

}

////////////////////////////////////////////////////////////////
// enums
////////////////////////////////////////////////////////////////

export enum DataType {

    ////////////////////////////////////////////////////////////////
    // basic
    ////////////////////////////////////////////////////////////////

    // non-entity

    BOOLEAN = 'DATA_TYPE.BOOLEAN',
    DATE_TIME = 'DATA_TYPE.DATE_TIME',
    ID = 'DATA_TYPE.ID',
    PERSON_NAME = 'DATA_TYPE.PERSON_NAME',
    
    // entity
    
    CASE = 'DATA_TYPE.CASE',
    CREDITOR = 'DATA_TYPE.CREDITOR',
    FILE = 'DATA_TYPE.FILE',
    SOURCE = 'DATA_TYPE.SOURCE',
    TAGS = 'DATA_TYPE.TAGS',

}

export interface Node {
    children?: Node[]
    [key: string]: any
}
